module.exports = __webpack_public_path__ + "fonts/SupercellHeadline-Bold.9cfa5879.woff2";